module.exports = __webpack_public_path__ + "img/banner-2.63976460.png";